import entries from "lodash/entries";
import fromPairs from "lodash/fromPairs";
import mapValues from "lodash/mapValues";
import omit from "lodash/omit";
import { camelizeApiKeys } from "PFCore/api/utils";
import { buildOriginalFilterPath } from "PFCore/helpers/filters";
import { AvailabilityRuleV2, Filters, Value } from "PFTypes";
import {
  ApiFilterGroupV2,
  FilterKeyV2,
  FiltersMetaV2,
  FiltersV2,
  FilterV2WithValueOnly,
  KnownFiltersV2,
  StandardFilterV2
} from "PFTypes/filters_v2";

export const parseApiFilterValues = (
  filterValues: Omit<Filters<Value>, "children">
): FiltersV2<FilterV2WithValueOnly> => {
  const filterGroups = entries(omit(filterValues, [ApiFilterGroupV2.Availability, "children"]));

  const filterValuePairs = filterGroups.flatMap(([group, filters]) =>
    entries(filters as Record<string, Value>).map(([name, value]) => {
      const originalPath = buildOriginalFilterPath(group as ApiFilterGroupV2, name as FilterKeyV2);

      return [name as FilterKeyV2, { originalPath, value }];
    })
  ) as [FilterKeyV2, StandardFilterV2][];

  const parsedFilterValues = fromPairs<FilterV2WithValueOnly>(
    filterValuePairs
  ) as FiltersV2<FilterV2WithValueOnly>;

  if (filterValues[ApiFilterGroupV2.Availability]) {
    parsedFilterValues[ApiFilterGroupV2.Availability] = {
      originalPath: buildOriginalFilterPath(ApiFilterGroupV2.Availability, KnownFiltersV2.Availability),
      value: camelizeApiKeys(filterValues[ApiFilterGroupV2.Availability]) as AvailabilityRuleV2
    };
  }

  return parsedFilterValues;
};
export const parseApiFilterValuesMeta = (
  filterValues: Filters<Value>
): FiltersMetaV2<FilterV2WithValueOnly> => ({
  mainFilters: parseApiFilterValues(omit(filterValues, "children")),
  childrenFilters: mapValues(parseApiFilterValues(filterValues.children || {}), (filterWithValueOnly) => ({
    ...filterWithValueOnly,
    isChildren: true
  }))
});
